import React from 'react';
import { motion } from 'framer-motion';

interface BodyMotionProps {
  children: React.ReactNode;
  className?: string;
}

const BodyMotion: React.FC<BodyMotionProps> = ({ children, className }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 30, scale: 0.98 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      transition={{
        duration: 1,
        ease: [0.25, 0.1, 0.25, 1],
      }}
    >
      {children}
    </motion.div>
  );
};

export default BodyMotion;
